import React, { useEffect, useState } from 'react';

const labels = {
  healthy:'Checks passed', degraded:'Check failed', loginRequired:'Sign-in needed',
  offline:'Shop computer offline', stale:'Checks overdue', notChecked:'Waiting for first check',
  notConfigured:'Scan a known product to set up checks',
};

export default function SupplierHealth({ shopId }) {
  const [suppliers, setSuppliers] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!shopId) return undefined;
    let active = true;
    setSuppliers([]);
    async function refresh() {
      try {
        const response = await fetch(`/api/suppliers/health?shopId=${encodeURIComponent(shopId)}`, { cache:'no-store' });
        if (!response.ok) throw new Error('Supplier monitoring status is unavailable.');
        const data = await response.json();
        if (active) { setSuppliers(data.suppliers || []); setError(''); }
      } catch (cause) { if (active) setError(cause.message); }
    }
    refresh();
    const timer = window.setInterval(refresh, 30000);
    return () => { active = false; window.clearInterval(timer); };
  }, [shopId]);
  if (!shopId) return null;
  return <section aria-label="Supplier monitoring" style={{ marginTop:14, borderTop:'1px solid #EAEEF6', paddingTop:12 }}>
    <h3 style={{ margin:'0 0 6px', fontSize:13 }}>Supplier monitoring</h3>
    <p style={{ margin:'0 0 10px', fontSize:11, color:'#6B7894', lineHeight:1.5 }}>
      Periodic search and basket checks during shop hours. Adding to a basket is verified separately when you confirm an add.
    </p>
    {error && <p role="status" style={{ color:'#9A6717', fontSize:11 }}>{error}</p>}
    {!error && suppliers.map(supplier => <div key={supplier.supplier} style={{ padding:'8px 0', fontSize:11, borderTop:'1px solid #F1F3F8' }}>
      <div style={{ display:'flex', justifyContent:'space-between', gap:10 }}>
        <strong>{supplier.supplier}</strong>
        <span role={supplier.alertActive ? 'alert' : undefined}
          style={{ color:supplier.status === 'healthy' ? '#0F9E57' : supplier.alertActive ? '#B42318' : '#9A6717' }}>
          {supplier.alertActive && !['offline', 'stale'].includes(supplier.status) ? 'Attention: ' : ''}{labels[supplier.status] || supplier.status}
        </span>
      </div>
      {supplier.lastCheckedAt && <div style={{ marginTop:4, color:'#6B7894' }}>
        Last checked {new Date(supplier.lastCheckedAt).toLocaleString('en-GB')}
      </div>}
      {supplier.configurationStatus === 'rejected' && <div style={{ marginTop:4, color:'#9A6717' }}>
        A supplier update failed validation. The previous settings are still active.
      </div>}
    </div>)}
  </section>;
}
